export const spacing = [0, 4, 8, 12, 16, 24, 32, 40, 48, 56, 64]

export const borderRadius = 7
export const smallBorderRadius = 3

export const buttonNavigationSize = 72
export const buttonNavigationIconSize = 20
export const buttonNavigationLinkWidth = 148

export const textFieldWidth = 210
export const textFieldHeight = 34

export const dropdownWidth = 145

export const searchFieldWidth = 374
export const searchFieldHeight = 45
export const searchFieldIcon = 19

export const sidebarWidth = 350
export const ownerRevealSidebarWidth = 400
export const searchPanelHeight = 85
export const searchPanelPaddingTop = 20
export const sidebarWidthMobile = 128

export const venueDetailsTypeIconWrapperWidth = 41
export const venueDetailsTypeIconWrapperHeight = 45
export const venueDetailsTypeIcon = 30

export const insightIconBox = 30
export const insightIconSize = 16

export const insightIconBoxMobile = 48
export const insightIconSizeMobile = 32

export const sidebarPhotosHeight = 54
export const sidebarPhotosWidth = 40

export const placeTooltipWidth = 240
export const placeTooltipHeight = 209
export const placeTooltipImageHeight = 85

export const insightsPageVerticalPadding = 60
export const insightsPageHorizontalPadding = 90

export const insightsPageRightGap = 32
export const insightsPageRightBtnWidth = 15
export const insightsPageRightBtnHeight = 111
export const insightsPageTopIconBoxSize = 50
export const insightsPageTopIconSize = 21
export const insightsPageTopCloseIconSize = 21

export const printModalWidth = 1200
export const printModalHeight = 840
export const printModalSidebarWidth = 330

export const compareSelectorElementHeight = 64
export const compareSelectorElementIcon = 20
export const compareSelectorEmptyIcon = 20
export const compareSelectorMapHeight = 584
export const compareSelectorErrorHeight = 48
export const compareSelectorErrorTop = 94

export const placeIndicatorIcon = 20

export const tradeAreaOverlapHeight = 600
export const tradeAreaOverlapChartHeight = 400
export const tradeAreaOverlapPointer = 13
export const tradeAreaOverlapPointerBorder = 3
export const tradeAreaOverlapPlaceLabelWidth = 203
export const tradeAreaOverlapPlaceLabelHeight = 105

export const reportsLogoWidth = 32
export const reportsHeaderHeight = 68
export const reportsToolbarHeight = 48
export const reportsToolbarIcon = 24
export const reportsToolbarSecondaryIcon = 18
export const reportsToolbarSmallIcon = 12
export const reportsSidebarWidth = 477
export const reportsSidebarHeaderHeight = 48

export const reportPageBreakHeight = 50

export const reportsToolbarLoadingWith = 600
export const reportsToolbarLoadingHeight = 300
export const reportsToolbarLoadingIcon = 36

export const reportsAddPlaceHolderHeight = 10
export const reportsAddPlaceHolderLastHeight = 50
export const reportsAddPlaceHolderIcon = 16

export const reportsAddWidgetModalWidth = 987
export const reportsAddWidgetModalHeight = 600
export const reportsAddWidgetModalSelectorWidth = 300
export const reportsAddWidgetModalHeaderHeight = 76
export const reportsAddWidgetModalSidebarWidth = 315
export const reportsAddWidgetModalFooterHeight = 204
export const reportsAddWidgetModalElementWidth = 230
export const reportsAddWidgetModalElementHeight = 130
export const reportsAddWidgetModalElementImageWidth = 192
export const reportsAddWidgetModalElementImageHeight = 96

export const reportsInternalHeaderHeight = 85
export const reportsInternalHeaderBtnWidth = 134

export const reportsBuilderPlaceSelectorInputHeight = 61
export const reportsBuilderPlaceSelectorInputBtnWidth = 177

export const reportsBuilderInfoWidth = 230
export const reportsBuilderInfoPlaceIcon = 9
export const reportsBuilderInfoPlaceIconBorderRadius = 2

export const reportsHomeSidebarWidth = 240
export const reportsHomeTitleIcon = 20
export const reportsHomeItemHeight = 35
export const reportsHomeItemIcon = 15
export const reportsHomeItemIconArrow = 10

export const reportsHomeMenuItemIcon = 16

export const reportsHomeTemplatesOverviewActionsMinWidth = 200
export const reportsHomeTemplatesItemWidth = 117
export const reportsHomeTemplatesItemHeight = 151
export const reportsHomeTemplatesItemOverlayIcon = 16

export const reportsHomeFilesItemSize = 151
export const reportEditorUserImageThumbnailSize = 100

export const reportsHomeReportsItemWidth = 117
export const reportsHomeReportsItemHeight = 151
export const reportsHomeReportsItemContentHeight = 36

export const reportsHomePrintsItemHeight = 40
export const reportsHomePrintsItemIcon = 17
export const reportsHomePrintsItemMinColumnWidth = 200

export const mapEditorTooltipAnchor = 15
export const mapEditorTooltipBorder = 2
export const mapEditorHeaderMainIconSize = 24
export const mapEditorHeaderMainIconWrapperSize = 36
export const mapEditorConfigModalWidth = 400

export const brandLogoTooltipSize = 64
export const brandLogoTooltipEditSize = 24

export const mapEditorMarkerIcon = 36

export const companySelectorWidth = 350
export const companySelectorInputHeight = 70
export const companySelectorOptionHeight = 58
export const companySelectorOptionImg = 50

export const mapStreetViewControlClose = 24

export const reportEditorTopBarHeight = 112
export const reportEditorTopBarHeaderMainIconSize = 36
export const reportEditorTopBarHeaderIconSize = 20
export const reportEditorTopBarToolbarIconSize = 16
export const reportEditorSidebarWidth = 277

export const reportEditorRulerSize = 14

export const reportEditorAddWidgetModalWidth = 884
export const reportEditorAddWidgetModalHeight = 600
export const reportEditorAddWidgetModalSelectorWidth = 300
export const reportEditorAddWidgetModalHeaderHeight = 76
export const reportEditorAddWidgetModalSidebarWidth = 315
export const reportEditorAddWidgetModalElementWidth = 192
export const reportEditorAddWidgetModalElementHeight = 130
export const reportEditorAddWidgetModalElementImageWidth = 192
export const reportEditorAddWidgetModalElementImageHeight = 96

export const reportEditorPlatformTransformerActionsBtnSize = 48
export const reportEditorPlatformTransformerActionsBtnIconSize = 20

export const reportEditorConfigModalGeneratorWidth = 442
export const reportEditorConfigModalGeneratorHeaderHeight = 46
export const reportEditorConfigModalGeneratorBottomHeight = 63
